import type { ExportJobDraft } from '../models/exportJob.types'

/** `YYYY/MM/DD` — the slash form the legacy wizard held and `buildPayload` converts to dashes. */
function legacyDay(date: Date): string {
  const year = String(date.getFullYear())
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

function shiftDays(from: Date, days: number): Date {
  const copy = new Date(from)
  copy.setDate(copy.getDate() + days)
  return copy
}

/**
 * A blank wizard draft, with legacy `resetExport()`'s defaults (`DataExportCreate.vue:229-265`):
 * the last 30 days ending yesterday, a 30-day refresh interval, and a descending export sort.
 *
 * `now` is a parameter so the factory stays pure — the legacy defaults were computed from an
 * ambient `new Date()` inside two module-level helpers, which is what made them untestable.
 */
export function createExportJobDraft(now: Date = new Date()): ExportJobDraft {
  const lastDate = shiftDays(now, -1)
  const firstDate = shiftDays(now, -29)
  return {
    name: '',
    description: '',
    platforms: [],
    selectedAccounts: {},
    template: null,
    columns: [],
    breakdowns: [],
    filters: [],
    sort: { field: null, order: -1 },
    dateRange: {
      option: 'custom',
      firstDate: legacyDay(firstDate),
      lastDate: legacyDay(lastDate),
      data_fetch_days: 30,
    },
    destination: {
      type: null,
      update_mode: null,
      emails: [],
      project_id: null,
      dataset_id: null,
    },
    schedule: { frequency: null, time_info: null },
  }
}
